export const REWORK_REASON_CODE = 'RW'; // Master rejection.reason_code used for Rework

